import React, { Component } from "react";
import Header from "../layout/header";
import Footer from "../layout/footer";
import Menu from "../layout/doctorLeftmenu";
import { Link } from "react-router-dom";
import $ from "jquery";
import { storage } from "../firebase";
import { courseRef, database } from "../firebase";
import moment from "moment";
import closeImg from "../images/close.png";
import ContentTextEditor from "../admin/newStoriesEditor";
export default class NewInsights extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CourseName: "",
      courseImage: null,
      fileName: false,
      progress: 0,
      id: null,
      // bannerFlag: false,
      bannerTitle: "",
      bannerDescription: "",
      whatyoudo: false,
      modelRight: [],
      CourseFields: [],
      CourseScore: "",
      whatyoudo_Description: "",
      rightModelTitle: "",
      WhatYouWillLearn: false,
      WhatYouWillLearnArray: [],
      WhatYouWillGet: false,
      WhatYouWillGetArray: [],
      Howdoesitwork: false,
      HowdoesitworkArray: [],
      PlatformsToolsFiles: [],
      PlatformsToolsFileNameFlag: false,
      PlatformsToolsFileName: null,
      CertificationsFiles: [],

      courseDetails: [],
      CertificationsFileNameFlag: false,
      CertificationsFileName: null,
      iconCourseFlag: false,
      iconCourseName: null,

      Websitelink: "",
      Accrediation: "",
      Accredtionscore: "",
      Modeoflearning: "",
      Level: "",
      Courserating: "",
      Language: "",
      skillsObj: [],
      skillArray: [],
      LengthandBreadth: "",
      RelevantCaseStudies: "",
      ToolsCovered: "",
      CapstoneProjectCovered: "",

      TrainerExperience: "",
      TrainerEducation: "",
      TeachingStyle: "",

      Ranking: "",
      GovtBodies: "",
      ProfessionalBodies: "",

      Mentorship: "",
      CareerCoach: "",
      Liveclasses: "",
      QuickUpskilling: "",
      ActiveLearning: "",
      JobAssistance: "",
      StudyMaterials: "",
      expertiseDataList: [],
      modeoflearning: [],
      institution: [],
      country: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateValidateSubmission = this.updateValidateSubmission.bind(this);
    this.handleChangePlatformsToolsFile =
      this.handleChangePlatformsToolsFile.bind(this);
    this.handleChangeCertifications =
      this.handleChangeCertifications.bind(this);
    this.handleChangeiconCourse = this.handleChangeiconCourse.bind(this);
    this.handleNumberChange = this.handleNumberChange.bind(this);
  }
  handleChange = (event) => {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
    });
  };

  componentDidMount() {
    // const url = new URL(window.location.href);
    //const searchParams3 = new URLSearchParams(url.search);
    let url_path = window.location.href.split("=");
    let keyId = url_path[1];
    this.renderList(keyId);
    this.getSkills();
  }
  async getSkills() {
    let dataList = [];
    await database.ref("skills").once("value", function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        if (ChildSnapshot.val().status == 'Active') {
          dataList.push({
            key: ChildSnapshot.key,
            skills: ChildSnapshot.val().skill,
          });
        }
      });
    });

    this.setState({ skillsObj: dataList });
  }
  handleNumberChange = (event) => {
    const re = /^[0-9\b]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      if (parseFloat(event.target.value) > 10) {
        $("#" + event.target.name).val("");
      }
    } else {
      $("#" + event.target.name).val("");
    }
  };
  async renderList(keyId) {
    //let dataList = []
    this.experienceList();
    this.modeoflearningList();
    this.institutionList();
    this.countryList();
    let id = keyId;
    const ref = id ? "/Course/" + id : "Course";
    const userRef = database.ref(ref);
    const valueRef = id
      ? userRef
      : await userRef.orderByChild("key").equalTo("value");
    const snapshot = await valueRef.once("value");
    const val = snapshot.val();
    console.log();
    if (val) {
      $("#CourseName").val(val.CourseName);
      $("#bannerTitle").val(val.bannerDetails[0].title);
      //$("#bannerDescription").val(val.bannerDetails[0].description)
      document.getElementById("toolsRTEbanner_rte-edit-view").innerHTML =
        val.bannerDetails[0].description;
      $("#toolsRTEbanner-value").val(val.bannerDetails[0].description);
      $("#whatyoudo_Description").val(val.whatyoudo_Description);
      $("#rightModelTitle").val(val.whatyoudo_rightModel[0].rightModelTitle);
      //alert(val.expertise);
      $("#universityName").val(val.universityName);
      $("#courseDescription").val(val.courseDescription);
      $("#expertise").val(val.expertise);
      $("#Websitelink").val(val.Websitelink);
      $("#Accrediation").val(val.Accrediation);
      $("#Country").val(val.Country);
      $("#Accredtionscore").val(val.Accredtionscore);
      $("#Modeoflearning").val(val.Modeoflearning);
      $("#Level").val(val.Level);
      $("#Courserating").val(val.Courserating);
      $("#Language").val(val.Language);
      if (val.CourseFields) {
        $("#LengthandBreadth").val(val.CourseFields[0].LengthandBreadth);
        $("#RelevantCaseStudies").val(val.CourseFields[0].RelevantCaseStudies);
        $("#ToolsCovered").val(val.CourseFields[0].ToolsCovered);
        $("#CapstoneProjectCovered").val(
          val.CourseFields[0].CapstoneProjectCovered
        );

        $("#TrainerExperience").val(val.CourseFields[0].TrainerExperience);
        $("#TrainerEducation").val(val.CourseFields[0].TrainerEducation);
        $("#TeachingStyle").val(val.CourseFields[0].TeachingStyle);

        $("#Ranking").val(val.CourseFields[0].Ranking);
        $("#GovtBodies").val(val.CourseFields[0].GovtBodies);
        $("#ProfessionalBodies").val(val.CourseFields[0].ProfessionalBodies);

        $("#Mentorship").val(val.CourseFields[0].Mentorship);
        $("#CareerCoach").val(val.CourseFields[0].CareerCoach);
        $("#Liveclasses").val(val.CourseFields[0].Liveclasses);
        $("#QuickUpskilling").val(val.CourseFields[0].QuickUpskilling);
        $("#ActiveLearning").val(val.CourseFields[0].ActiveLearning);
        $("#JobAssistance").val(val.CourseFields[0].JobAssistance);
        $("#StudyMaterials").val(val.CourseFields[0].StudyMaterials);

        if (val.outcomes[0].CareerTransition === "True") {
          $("#CareerTransition").prop("checked", true);
        }
        if (val.outcomes[0].QuickUpskills === "True") {
          $("#QuickUpskills").prop("checked", true);
        }
        if (val.outcomes[0].Jobs === "True") {
          $("#Jobs").prop("checked", true);
        }
        if (val.outcomes[0].Certificates === "True") {
          $("#CertificatesCheck").prop("checked", true);
        }
        if (val.outcomes.length == 2) {
          if (val.outcomes[1].CareerTransitionScore) {
            $("#careerTransitionScore").val(val.outcomes[1].CareerTransitionScore);
          }
          if (val.outcomes[1].QuickUpskillsScore) {
            $("#quickUpskillsScore").val(val.outcomes[1].QuickUpskillsScore);
          }
          if (val.outcomes[1].JobsScore) {
            $("#jobsScore").val(val.outcomes[1].JobsScore);
          }
          if (val.outcomes[1].CertificatesScore) {
            $("#certificatesScore").val(val.outcomes[1].CertificatesScore);
          }
        }
      }
      this.setState({
        modelRight: val.whatyoudo_rightModel[0].modelData
          ? val.whatyoudo_rightModel[0].modelData
          : [],
      });

      this.setState({
        CourseUrl: val.imageUrl ? val.imageUrl : null,
        courseImage: val.imageUrl ? val.imageUrl : null,
        id: id,
      });
      this.setState({
        CourseUrl: val.imageUrl ? val.imageUrl : null,
        courseImage: val.imageUrl ? val.imageUrl : null,
        id: id,
        CourseName: $("#CourseName").val(),
        bannerTitle: val.bannerDetails[0].title,
        bannerDescription: val.bannerDetails[0].description,
        whatyoudo_Description: val.whatyoudo_Description,
        rightModelTitle: val.whatyoudo_rightModel[0].rightModelTitle,
        //  modelRight: val.whatyoudo_rightModel[0].modelData,
        WhatYouWillLearnArray: val.WhatYouWillLearn ? val.WhatYouWillLearn : [],
        WhatYouWillGetArray: val.WhatYouWillGet ? val.WhatYouWillGet : [],
        HowdoesitworkArray: val.Howdoesitwork ? val.HowdoesitworkArray : [],
        PlatformsToolsFiles: val.PlatformsToolsFiles
          ? val.PlatformsToolsFiles
          : [],
        CertificationsFiles: val.CertificationsFiles
          ? val.CertificationsFiles
          : [],

        Websitelink: val.Websitelink,
        Accrediation: val.Accrediation,
        Accredtionscore: val.Accredtionscore,
        Modeoflearning: val.Modeoflearning,
        Level: val.Level,
        Courserating: val.Courserating,
        Language: val.Language,
        skillArray: val.skills ? val.skills : [],
        CourseScore: val.CourseFields[0].CourseScore,
        //courseDetails:val.courseDetails[0].shortDescription
      });
    }
  }

  handleChangePlatformsToolsFile = (e) => {
    if (e.target.files[0]) {
      this.setState({
        PlatformsToolsFileName: e.target.files[0],
        PlatformsToolsFileNameFlag: true,
      });
    }
  };

  handleChangeCertifications = (e) => {
    if (e.target.files[0]) {
      this.setState({
        CertificationsFileName: e.target.files[0],
        CertificationsFileNameFlag: true,
      });
    }
  };
  handleChangeiconCourse = (e) => {
    if (e.target.files[0]) {
      this.setState({
        iconCourseName: e.target.files[0],
        iconCourseFlag: true,
      });
    }
  };

  handleImageChange = (e) => {
    if (e.target.files[0]) {
      this.setState({
        courseImage: e.target.files[0],
        fileName: true,
      });
    }
  };
  validateSubmission = () => {
    console.log("this.state.courseImage...", this.state.courseImage);
    console.log("this.state.CourseUrl...", this.state.CourseUrl);
    if ($("#CourseName").val() === "") {
      alert("Enter Course Name");
    } else if (
      this.state.courseImage === "" ||
      this.state.courseImage === null
    ) {
      alert("Upload File ");
    } else if ($("#universityName").val() === "") {
      alert("Enter University Name");
    } else if ($("#courseDescription").val() === "") {
      alert("Enter Course Description");
    }
    // else if (this.state.modelRight.length === 0) {
    //     alert("Please Fill What you'll do")
    // }
    // else if (this.state.WhatYouWillLearnArray.length === 0) {
    //     alert("Please Fill What You Will Learn")
    // }
    // else if (this.state.WhatYouWillGetArray.length === 0) {
    //     alert("Please Fill What You Will Get")
    // }
    // else if (this.state.HowdoesitworkArray.length === 0) {
    //     alert("Please Fill How does it work ")
    // }
    // else if (this.state.PlatformsToolsFiles.length === 0) {
    //     alert("Please Fill Plat forms Tools Files ")
    // }
    // else if (this.state.CertificationsFiles.length === 0) {
    //     alert("Please Fill Certifications Files ")
    // }
    // else if(this.state.skillArray.length === 0 ) {
    //     alert("Please select skills  ")
    // }
    else {
      console.log("this.state.courseImage...", this.state.courseImage);
      if (this.state.fileName) {
        const uploadTask = storage
          .ref(`Course/${this.state.courseImage.name}`)
          .put(this.state.courseImage);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            this.setState({
              progress: progress,
            });
          },
          (error) => {
            console.log(error);
          },
          () => {
            storage
              .ref("Course")
              .child(this.state.courseImage.name)
              .getDownloadURL()
              .then((url) => {
                console.log("url...", url);
                $("#imageUrl").attr("src", url);
                this.setState({
                  url: url,
                });
                if (this.state.id == null) {
                  this.handleSubmit(url);
                } else {
                  this.updateValidateSubmission(url);
                }
              });
          }
        );
      } else {
        if (this.state.id == null) {
          this.handleSubmit("");
        } else {
          this.updateValidateSubmission("");
        }
      }
    }
  };
  updateValidateSubmission = (url) => {
    // alert($("#expertise").val());
    this.scoreCalculate();
    console.log(
      ">>>>>",
      this.state.HowdoesitworkArray === undefined
        ? []
        : this.state.HowdoesitworkArray
    );
    let bannerDescriptionContent = document.getElementById(
      "toolsRTEbanner_rte-edit-view"
    ).innerHTML;
    let newDate = moment(new Date()).format("DD/MM/YYYY");
    let outcomes = [];
    let CareerTransition = "False";
    let QuickUpskills = "False";
    let Jobs = "False";
    let CertificatesCheck = "False";

    let careerTransitionScore = 0;
    let quickUpskillsScore = 0;
    let jobsScore = 0;
    let certificatesScore = 0;


    if ($("#CareerTransition:checked").val() != undefined) {
      CareerTransition = "True";
    }
    if ($("#QuickUpskills:checked").val() != undefined) {
      QuickUpskills = "True";
    }
    if ($("#Jobs:checked").val() != undefined) {
      Jobs = "True";
    }
    if ($("#CertificatesCheck:checked").val() != undefined) {
      CertificatesCheck = "True";
    }

    if ($("#careerTransitionScore").val() != "") {
      careerTransitionScore = $("#careerTransitionScore").val();
    }
    if ($("#quickUpskillsScore").val() != "") {
      quickUpskillsScore = $("#quickUpskillsScore").val();
    }
    if ($("#jobsScore").val() != "") {
      jobsScore = $("#jobsScore").val();
    }
    if ($("#certificatesScore").val() != "") {
      certificatesScore = $("#certificatesScore").val();
    }

    outcomes.push({
      CareerTransition: CareerTransition,
      QuickUpskills: QuickUpskills,
      Jobs: Jobs,
      Certificates: CertificatesCheck,
    });
    outcomes.push({
      CareerTransitionScore: careerTransitionScore,
      QuickUpskillsScore: quickUpskillsScore,
      JobsScore: jobsScore,
      CertificatesScore: certificatesScore,
    });
    var skillArray = this.state.skillArray;
    var newArray = [];
    skillArray.map((data, i) => {

      if (data.skillRating == "" || data.skillRating == undefined) {
        data.skillRating = 0
      }
      newArray.push({ skill: data.skill, skillRating: data.skillRating });

    });
    this.setState({ skillArray: newArray });
    const item = {
      CourseName: $("#CourseName").val(),
      imageUrl: url ? url : this.state.courseImage,
      createdAt: newDate,
      bannerDetails: [
        {
          title: this.state.bannerTitle,
          description: bannerDescriptionContent,
        },
      ],
      whatyoudo_Description: this.state.whatyoudo_Description,
      whatyoudo_rightModel: [
        {
          rightModelTitle: this.state.rightModelTitle,
          modelData: this.state.modelRight,
        },
      ],
      WhatYouWillLearn: this.state.WhatYouWillLearnArray,
      WhatYouWillGet: this.state.WhatYouWillGetArray,
      Howdoesitwork:
        this.state.HowdoesitworkArray === undefined
          ? []
          : this.state.HowdoesitworkArray,
      PlatformsToolsFiles: this.state.PlatformsToolsFiles,
      CertificationsFiles: this.state.CertificationsFiles,
      universityName: $("#universityName").val(),
      courseDescription: $("#courseDescription").val(),
      Websitelink: this.state.Websitelink,
      Accrediation: this.state.Accrediation,
      Accredtionscore: this.state.Accredtionscore,
      Modeoflearning: $("#Modeoflearning").val(),
      Country: $("#Country").val(),
      Level: this.state.Level,
      Courserating: this.state.Courserating,
      Language: this.state.Language,
      skills: this.state.skillArray,
      expertise: $("#expertise").val(),
      CourseFields: [
        {
          CourseScore: this.state.CourseScore,
          LengthandBreadth:
            $("#LengthandBreadth").val() == ""
              ? 0
              : $("#LengthandBreadth").val(),
          RelevantCaseStudies:
            $("#RelevantCaseStudies").val() == ""
              ? 0
              : $("#RelevantCaseStudies").val(),
          ToolsCovered:
            $("#ToolsCovered").val() == "" ? 0 : $("#ToolsCovered").val(),
          CapstoneProjectCovered:
            $("#CapstoneProjectCovered").val() == ""
              ? 0
              : $("#CapstoneProjectCovered").val(),

          TrainerExperience:
            $("#TrainerExperience").val() == ""
              ? 0
              : $("#TrainerExperience").val(),
          TrainerEducation:
            $("#TrainerEducation").val() == ""
              ? 0
              : $("#TrainerEducation").val(),
          TeachingStyle:
            $("#TeachingStyle").val() == "" ? 0 : $("#TeachingStyle").val(),

          Ranking: $("#Ranking").val() == "" ? 0 : $("#Ranking").val(),
          GovtBodies: $("#GovtBodies").val() == "" ? 0 : $("#GovtBodies").val(),
          ProfessionalBodies:
            $("#ProfessionalBodies").val() == ""
              ? 0
              : $("#ProfessionalBodies").val(),

          Mentorship: $("#Mentorship").val() == "" ? 0 : $("#Mentorship").val(),
          CareerCoach:
            $("#CareerCoach").val() == "" ? 0 : $("#CareerCoach").val(),
          Liveclasses:
            $("#Liveclasses").val() == "" ? 0 : $("#Liveclasses").val(),
          QuickUpskilling:
            $("#QuickUpskilling").val() == "" ? 0 : $("#QuickUpskilling").val(),
          ActiveLearning:
            $("#ActiveLearning").val() == "" ? 0 : $("#ActiveLearning").val(),
          JobAssistance:
            $("#JobAssistance").val() == "" ? 0 : $("#JobAssistance").val(),
          StudyMaterials:
            $("#StudyMaterials").val() == "" ? 0 : $("#StudyMaterials").val(),
        },
      ],
      outcomes: outcomes,
      // courseDetails:[{universityName:$("#universityName").val(),courseDescription:$("#courseDescription").val(),shortDescription:this.state.courseDetails}]
    };
    console.log(">>>>>>>>>>>>>>>>>>>>>>::::::", item);
    database
      .ref(`Course/${this.state.id}`)
      .update(item)
      .then(() => {
        alert("Updated Successfully");
        window.location.href = "/career-tracks";
        this.renderList();
      })
      .catch(() => {
        alert("Somthing went wrong");
      });
  };

  handleSubmit = (url) => {
    this.scoreCalculate();
    let newDate = moment(new Date()).format("DD/MM/YYYY");
    let bannerDescriptionContent = document.getElementById(
      "toolsRTEbanner_rte-edit-view"
    ).innerHTML;
    let whatyoudoDescriptionContent = document.getElementById(
      "toolsRTEwhatyoudo_rte-edit-view"
    ).innerHTML;
    let outcomes = [];
    let CareerTransition = "False";
    let QuickUpskills = "False";
    let Jobs = "False";
    let CertificatesCheck = "False";

    let careerTransitionScore = 0;
    let quickUpskillsScore = 0;
    let jobsScore = 0;
    let certificatesScore = 0;

    if ($("#CareerTransition:checked").val() != undefined) {
      CareerTransition = "True";
    }
    if ($("#QuickUpskills:checked").val() != undefined) {
      QuickUpskills = "True";
    }
    if ($("#Jobs:checked").val() != undefined) {
      Jobs = "True";
    }
    if ($("#CertificatesCheck:checked").val() != undefined) {
      CertificatesCheck = "True";
    }

    if ($("#careerTransitionScore").val() != "") {
      careerTransitionScore = $("#careerTransitionScore").val();
    }
    if ($("#quickUpskillsScore").val() != "") {
      quickUpskillsScore = $("#quickUpskillsScore").val();
    }
    if ($("#jobsScore").val() != "") {
      jobsScore = $("#jobsScore").val();
    }
    if ($("#certificatesScore").val() != "") {
      certificatesScore = $("#certificatesScore").val();
    }

    outcomes.push({
      CareerTransition: CareerTransition,
      QuickUpskills: QuickUpskills,
      Jobs: Jobs,
      Certificates: CertificatesCheck,
    });
    outcomes.push({
      CareerTransitionScore: careerTransitionScore,
      QuickUpskillsScore: quickUpskillsScore,
      JobsScore: jobsScore,
      CertificatesScore: certificatesScore,
    });
    const item = {
      CourseName: $("#CourseName").val(),
      expertise: $("#expertise").val(),
      imageUrl: url ? url : this.state.courseImage,
      createdAt: newDate,
      bannerDetails: [
        {
          title: this.state.bannerTitle,
          description: bannerDescriptionContent,
        },
      ],
      whatyoudo_Description: whatyoudoDescriptionContent,
      whatyoudo_rightModel: [
        {
          rightModelTitle: this.state.rightModelTitle,
          modelData: this.state.modelRight,
        },
      ],
      WhatYouWillLearn: this.state.WhatYouWillLearnArray,
      WhatYouWillGet: this.state.WhatYouWillGetArray,
      Howdoesitwork: this.state.HowdoesitworkArray,
      PlatformsToolsFiles: this.state.PlatformsToolsFiles,
      CertificationsFiles: this.state.CertificationsFiles,
      universityName: $("#universityName").val(),
      courseDescription: $("#courseDescription").val(),
      Websitelink: this.state.Websitelink,
      Accrediation: this.state.Accrediation,
      Accredtionscore: this.state.Accredtionscore,
      Modeoflearning: $("#Modeoflearning").val(),
      Country: $("#Country").val(),
      Level: this.state.Level,
      Courserating: this.state.Courserating,
      Language: this.state.Language,
      skills: this.state.skillArray,

      CourseFields: [
        {
          CourseScore: this.state.CourseScore,
          LengthandBreadth:
            $("#LengthandBreadth").val() == ""
              ? 0
              : $("#LengthandBreadth").val(),
          RelevantCaseStudies:
            $("#RelevantCaseStudies").val() == ""
              ? 0
              : $("#RelevantCaseStudies").val(),
          ToolsCovered:
            $("#ToolsCovered").val() == "" ? 0 : $("#ToolsCovered").val(),
          CapstoneProjectCovered:
            $("#CapstoneProjectCovered").val() == ""
              ? 0
              : $("#CapstoneProjectCovered").val(),

          TrainerExperience:
            $("#TrainerExperience").val() == ""
              ? 0
              : $("#TrainerExperience").val(),
          TrainerEducation:
            $("#TrainerEducation").val() == ""
              ? 0
              : $("#TrainerEducation").val(),
          TeachingStyle:
            $("#TeachingStyle").val() == "" ? 0 : $("#TeachingStyle").val(),

          Ranking: $("#Ranking").val() == "" ? 0 : $("#Ranking").val(),
          GovtBodies: $("#GovtBodies").val() == "" ? 0 : $("#GovtBodies").val(),
          ProfessionalBodies:
            $("#ProfessionalBodies").val() == ""
              ? 0
              : $("#ProfessionalBodies").val(),

          Mentorship: $("#Mentorship").val() == "" ? 0 : $("#Mentorship").val(),
          CareerCoach:
            $("#CareerCoach").val() == "" ? 0 : $("#CareerCoach").val(),
          Liveclasses:
            $("#Liveclasses").val() == "" ? 0 : $("#Liveclasses").val(),
          QuickUpskilling:
            $("#QuickUpskilling").val() == "" ? 0 : $("#QuickUpskilling").val(),
          ActiveLearning:
            $("#ActiveLearning").val() == "" ? 0 : $("#ActiveLearning").val(),
          JobAssistance:
            $("#JobAssistance").val() == "" ? 0 : $("#JobAssistance").val(),
          StudyMaterials:
            $("#StudyMaterials").val() == "" ? 0 : $("#StudyMaterials").val(),
        },
      ],
      outcomes: outcomes,
      //courseDetails:[{universityName:$("#universityName").val(),
      //courseDescription:$("#courseDescription").val(),shortDescription:this.state.courseDetails}]
    };
    console.log(item);
    courseRef
      .push(item)
      .then(() => {
        alert("Saved Successfully");
        window.location.href = "/career-tracks";
      })
      .catch(() => {
        alert("Somthing went wrong");
      });
  };

  // addBannerDetails() {

  //     if (this.state.bannerFlag == true) {
  //         $("#bannerDetails").hide();
  //         this.setState({ bannerFlag: false })
  //     }
  //     else {
  //         $("#bannerDetails").show();
  //         this.setState({ bannerFlag: true })
  //     }
  // }
  whatyoudo() {
    if (this.state.whatyoudo == true) {
      $("#whatyoudo").hide();
      this.setState({ whatyoudo: false });
    } else {
      $("#whatyoudo").show();
      this.setState({ whatyoudo: true });
    }
  }
  whatyoudoRight() {
    var modelRight = this.state.modelRight;
    modelRight.push({
      date: $("#modelDate").val(),
      price: $("#modelPrice").val(),
      duration: $("#modelDuration").val(),
    });
    this.setState({ modelRight: modelRight });
    $("#modelDate").val("");
    $("#modelPrice").val("");
    $("#modelDuration").val("");
  }
  courseDetailsAdd() {
    // var courseDetails=this.state.courseDetails;
    // courseDetails.push({ shortIcon: $("#modelDate").val(), shortDescription: $("#shortDescription").val()})
    //  this.setState({ courseDetails: courseDetails });
    $("#iconCourse").val("");
    $("#courseDetails").val("");
  }
  courseDetailsIconAdd = () => {
    if (this.state.iconCourseFlag === true) {
      const uploadTask = storage
        .ref(`Course/${this.state.iconCourseName.name}`)
        .put(this.state.iconCourseName);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          this.setState({
            progress: progress,
          });
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref("Course")
            .child(this.state.iconCourseName.name)
            .getDownloadURL()
            .then((url) => {
              console.log("url...", url);
              $("#imageUrl").attr("src", url);
              var newArrays = this.state.courseDetails;

              newArrays.push({
                url: url,
                shortDescription: $("#shortDescription").val(),
              });
              this.setState({
                courseDetails: newArrays,
                iconCourseFlag: false,
                iconCourseName: null,
              });
              $("#shortDescription").val("");
            });
        }
      );
    }
  };
  WhatYouWillLearnAdd() {
    var WhatYouWillLearnArray = this.state.WhatYouWillLearnArray;
    WhatYouWillLearnArray.push({
      title: $("#WhatYouWillLearnTitle").val(),
      description: document.getElementById(
        "toolsRTEWhatYouWillLearn_rte-edit-view"
      ).innerHTML,
    });
    this.setState({ WhatYouWillLearnArray: WhatYouWillLearnArray });
    $("#WhatYouWillLearnTitle").val("");
    $("#WhatYouWillLearnDescription").val("");
  }
  HowdoesitworkAdd() {
    var HowdoesitworkArray = this.state.HowdoesitworkArray;
    HowdoesitworkArray.push({
      title: $("#HowdoesitworkTitle").val(),
      description: document.getElementById(
        "toolsRTEHowdoesitwork_rte-edit-view"
      ).innerHTML,
    });
    this.setState({ HowdoesitworkArray: HowdoesitworkArray });
    $("#HowdoesitworkTitle").val("");
    $("#HowdoesitworkDescription").val("");
  }

  PlatformsToolsAdd = () => {
    if (this.state.PlatformsToolsFileNameFlag === true) {
      const uploadTask = storage
        .ref(`Course/${this.state.PlatformsToolsFileName.name}`)
        .put(this.state.PlatformsToolsFileName);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          this.setState({
            progress: progress,
          });
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref("Course")
            .child(this.state.PlatformsToolsFileName.name)
            .getDownloadURL()
            .then((url) => {
              console.log("url...", url);
              $("#imageUrl").attr("src", url);
              var newArray = this.state.PlatformsToolsFiles;
              newArray.push({ url: url });
              this.setState({
                PlatformsToolsFiles: newArray,
                PlatformsToolsFileNameFlag: false,
                PlatformsToolsFileName: null,
              });
            });
        }
      );
    }
  };
  CertificationsAdd = () => {
    if (this.state.CertificationsFileNameFlag === true) {
      const uploadTask = storage
        .ref(`Course/${this.state.CertificationsFileName.name}`)
        .put(this.state.CertificationsFileName);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          this.setState({
            progress: progress,
          });
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref("Course")
            .child(this.state.CertificationsFileName.name)
            .getDownloadURL()
            .then((url) => {
              console.log("url...", url);
              $("#imageUrl").attr("src", url);
              var newArrays = this.state.CertificationsFiles;
              newArrays.push({ url: url });
              this.setState({
                CertificationsFiles: newArrays,
                CertificationsFileNameFlag: false,
                CertificationsFileName: null,
              });
            });
        }
      );
    }
  };

  skillAdd() {
    if ($("#skilsName").val() === "") {
      alert("please select skill");
    } else {
      var skillRating = 0
      if ($("#skillRating").val() != "") {
        skillRating = $("#skillRating").val()
      }
      var skillArray = this.state.skillArray;
      skillArray.push({ skill: $("#skilsName").val(), skillRating: skillRating });
      this.setState({ skillArray: skillArray });
      $("#skilsName").val("");
      $("#skillRating").val("");
    }
  }
  WhatYouWillGetAdd() {
    var WhatYouWillGetArray = this.state.WhatYouWillGetArray;
    WhatYouWillGetArray.push({ title: $("#WhatYouWillGetTitle").val() });
    this.setState({ WhatYouWillGetArray: WhatYouWillGetArray });
    $("#WhatYouWillGetTitle").val("");
  }
  WhatYouWillLearn() {
    if (this.state.WhatYouWillLearn == true) {
      $("#WhatYouWillLearn").hide();
      this.setState({ WhatYouWillLearn: false });
    } else {
      $("#WhatYouWillLearn").hide();
      this.setState({ WhatYouWillLearn: false });
    }
  }
  WhatYouWillGet() {
    if (this.state.WhatYouWillGet == true) {
      $("#WhatYouWillGet").hide();
      this.setState({ WhatYouWillGet: false });
    } else {
      $("#WhatYouWillGet").hide();
      this.setState({ WhatYouWillGet: false });
    }
  }

  Howdoesitwork() {
    if (this.state.Howdoesitwork == true) {
      $("#Howdoesitwork").hide();
      this.setState({ Howdoesitwork: false });
    } else {
      $("#Howdoesitwork").hide();
      this.setState({ Howdoesitwork: false });
    }
  }
  PlatformsTools() {
    if (this.state.PlatformsTools == true) {
      $("#PlatformsTools").hide();
      this.setState({ PlatformsTools: false });
    } else {
      $("#PlatformsTools").hide();
      this.setState({ PlatformsTools: false });
    }
  }
  Certifications() {
    if (this.state.Certifications == true) {
      $("#Certifications").hide();
      this.setState({ Certifications: false });
    } else {
      $("#Certifications").hide();
      this.setState({ Certifications: false });
    }
  }

  modelRightRemove(a, b, c) {
    var modelRight = this.state.modelRight;
    var newArray = [];
    modelRight.map((data, i) => {
      if (data.date !== a && data.price !== b && data.duration !== c) {
        newArray.push({
          date: data.date,
          price: data.price,
          duration: data.duration,
        });
      }
    });
    this.setState({ modelRight: newArray });
  }
  WhatYouWillLearnArrayRemove(a, b) {
    var WhatYouWillLearnArray = this.state.WhatYouWillLearnArray;
    var newArray = [];
    WhatYouWillLearnArray.map((data, i) => {
      if (data.title !== a && data.description !== b) {
        newArray.push({ title: data.title, description: data.description });
      }
    });
    this.setState({ WhatYouWillLearnArray: newArray });
  }

  PlatformsToolsRemove(a) {
    var PlatformsToolsFiles = this.state.PlatformsToolsFiles;
    var newArray = [];
    PlatformsToolsFiles.map((data, i) => {
      if (data.url !== a) {
        newArray.push({ url: data.url });
      }
    });
    this.setState({ PlatformsToolsFiles: newArray });
  }
  CertificationsRemove(a) {
    var CertificationsFiles = this.state.CertificationsFiles;
    var newArray = [];
    CertificationsFiles.map((data, i) => {
      if (data.url !== a) {
        newArray.push({ url: data.url });
      }
    });
    this.setState({ CertificationsFiles: newArray });
  }
  courseDetailsRemove(a) {
    var courseDetails = this.state.courseDetails;
    var newArray = [];
    courseDetails.map((data, i) => {
      if (data.url !== a) {
        newArray.push({
          url: data.url,
          shortDescription: data.shortDescription,
        });
      }
    });
    this.setState({ courseDetails: newArray });
  }
  HowdoesitworkArrayRemove(a, b) {
    var HowdoesitworkArray = this.state.HowdoesitworkArray;
    var newArray = [];
    HowdoesitworkArray.map((data, i) => {
      if (data.title !== a && data.description !== b) {
        newArray.push({ title: data.title, description: data.description });
      }
    });
    this.setState({ HowdoesitworkArray: newArray });
  }

  WhatYouWillGetRemove(a) {
    var WhatYouWillGetArray = this.state.WhatYouWillGetArray;
    var newArray = [];
    WhatYouWillGetArray.map((data, i) => {
      if (data.title !== a) {
        newArray.push({ title: data.title });
      }
    });
    this.setState({ WhatYouWillGetArray: newArray });
  }
  skillRemove(a) {
    var skillArray = this.state.skillArray;
    var newArray = [];
    skillArray.map((data, i) => {
      if (data.skill !== a) {
        if (data.skillRating == "" || data.skillRating == undefined) {
          data.skillRating = 0
        }
        newArray.push({ skill: data.skill, skillRating: data.skillRating });
      }
    });
    this.setState({ skillArray: newArray });
  }

  scoreCalculate() {
    let LengthandBreadth = $("#LengthandBreadth").val();
    let RelevantCaseStudies = $("#RelevantCaseStudies").val();
    let ToolsCovered = $("#ToolsCovered").val();
    let CapstoneProjectCovered = $("#CapstoneProjectCovered").val();
    LengthandBreadth =
      LengthandBreadth == "" ? 0 : parseFloat(LengthandBreadth);
    RelevantCaseStudies =
      RelevantCaseStudies == "" ? 0 : parseFloat(RelevantCaseStudies);
    ToolsCovered = ToolsCovered == "" ? 0 : parseFloat(ToolsCovered);
    CapstoneProjectCovered =
      CapstoneProjectCovered == "" ? 0 : parseFloat(CapstoneProjectCovered);
    let total1 =
      ((LengthandBreadth +
        RelevantCaseStudies +
        ToolsCovered +
        CapstoneProjectCovered) *
        100) /
      40;

    total1 = (total1 * 25) / 100;
    //-----------------------------------------------------------------
    let TrainerExperience =
      $("#TrainerExperience").val() == ""
        ? 0
        : parseFloat($("#TrainerExperience").val());
    let TrainerEducation =
      $("#TrainerEducation").val() == ""
        ? 0
        : parseFloat($("#TrainerEducation").val());
    let TeachingStyle =
      $("#TeachingStyle").val() == ""
        ? 0
        : parseFloat($("#TeachingStyle").val());
    let total2 =
      ((TrainerExperience + TrainerEducation + TeachingStyle) * 100) / 30;

    total2 = (total2 * 25) / 100;
    //-------------------------------------------------------------------------
    let Ranking =
      $("#Ranking").val() == "" ? 0 : parseFloat($("#Ranking").val());
    let GovtBodies =
      $("#GovtBodies").val() == "" ? 0 : parseFloat($("#GovtBodies").val());
    let ProfessionalBodies =
      $("#ProfessionalBodies").val() == ""
        ? 0
        : parseFloat($("#ProfessionalBodies").val());
    let total3 = ((Ranking
      // +GovtBodies + ProfessionalBodies
    ) * 100) / 10;
    total3 = (total3 * 20) / 100;
    //-------------------------------------------------------------------------
    let Mentorship =
      $("#Mentorship").val() == "" ? 0 : parseFloat($("#Mentorship").val());
    let CareerCoach =
      $("#CareerCoach").val() == "" ? 0 : parseFloat($("#CareerCoach").val());
    let Liveclasses =
      $("#Liveclasses").val() == "" ? 0 : parseFloat($("#Liveclasses").val());
    let QuickUpskilling =
      $("#QuickUpskilling").val() == "" ? 0 : parseFloat($("#QuickUpskilling").val());
    let ActiveLearning =
      $("#ActiveLearning").val() == ""
        ? 0
        : parseFloat($("#ActiveLearning").val());
    let JobAssistance =
      $("#JobAssistance").val() == ""
        ? 0
        : parseFloat($("#JobAssistance").val());
    let StudyMaterials =
      $("#StudyMaterials").val() == ""
        ? 0
        : parseFloat($("#StudyMaterials").val());
    let total4 =
      ((
        // Mentorship +
        // CareerCoach +
        // Liveclasses +
        QuickUpskilling +
        ActiveLearning +
        JobAssistance +
        StudyMaterials) *
        100) /
      40;
    total4 = (total4 * 30) / 100;

    let finalTotal = total1 + total2 + total3 + total4;
    finalTotal = finalTotal.toFixed(2);

    $("#scoreValue").html(finalTotal + " %");
    this.setState({ CourseScore: finalTotal });
  }
  async experienceList() {
    let dataList = [];
    await database.ref("expertise").once("value", function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        dataList.push({
          key: ChildSnapshot.key,
          expertise: ChildSnapshot.val().expertise,
          expertiseStatus: ChildSnapshot.val().status,
        });
      });
    });
    this.setState({
      expertiseDataList: dataList,
    });
  }
  async modeoflearningList() {
    let dataList = [];
    await database.ref("modeOfLearning").once("value", function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        if (ChildSnapshot.val().status == 'Active') {
          dataList.push({
            key: ChildSnapshot.key,
            modeOfLearning: ChildSnapshot.val().modeOfLearning,
            modeOfLearningStatus: ChildSnapshot.val().status,
            internalId: ChildSnapshot.val().internalId,
          });
        }
      });
    });
    this.setState({
      modeoflearning: dataList,
    });
  }
  async institutionList() {
    let dataList = [];
    await database.ref("institution").once("value", function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        if (ChildSnapshot.val().status == 'Active') {
          dataList.push({
            key: ChildSnapshot.key,
            institution: ChildSnapshot.val().institution,
            modeOfLearningStatus: ChildSnapshot.val().status,
            internalId: ChildSnapshot.val().internalId,
          });
        }
      });
    });
    this.setState({
      institution: dataList,
    });
  }
  async countryList() {
    let countryList = []
    await database.ref("country").once('value', function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        if (ChildSnapshot.val().status == 'Active') {
          countryList.push({
            key: ChildSnapshot.key,
            country: ChildSnapshot.val().country
          });
        }
      });
    });
    this.setState({
      country: countryList
    })
  }
  render() {
    return (
      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content">
          <Menu></Menu>
          <div className="content-right-wrapper">
            <div className="container">
              <form className="form-wrapper">
                <ul className="breadcrumb">
                  <li>
                    <a href="/dashboard">Dashboard</a>
                  </li>
                  <li>
                    <a href="/career-tracks">Career Tracks List</a>
                  </li>
                  <li>Career Tracks</li>
                </ul>
                <div className="form-head">Courses</div>
                <div className="form-group">
                  <label for="insightTitle">Expertise</label>
                  <select
                    id="expertise"
                    name="expertise"
                    className="form-control"
                  >
                    {this.state.expertiseDataList.map((data, i) => {
                      return (
                        <option value={data.expertise}>{data.expertise}</option>
                      );
                    })}
                  </select>
                </div>

                <div className="form-group">
                  <label for="insightTitle">Course Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="CourseName"
                    id="CourseName"
                    onChange={this.handleChange}
                    defaultValue={this.state.CourseName}
                  />
                </div>

                <div className="form-group">
                  <label for="imageUrl">Image</label>
                  <input
                    type="file"
                    onChange={this.handleImageChange}
                    id="imageUrl"
                    name="imageUrl"
                    className="form-control"
                  ></input>
                  {/* {this.state.fileName || this.state.testimonialUrl && <img src={this.state.testimonialUrl} id={"imageUrl"} style={{ width: "100px", height: "100px" }} />} */}
                </div>

                <div className="form-group">
                  <button type="button" className="btn btn-primary">
                    {" "}
                    Banner
                  </button>
                </div>

                <div className="form-group">
                  <label for="bannerTitle">Banner Title</label>
                  <input
                    type="text"
                    className="form-control"
                    name="bannerTitle"
                    id="bannerTitle"
                    onChange={this.handleChange}
                    defaultValue={this.state.bannerTitle}
                  />
                </div>
                <div className="form-group" style={{ display: "none" }}>
                  <label for="bannerDescription">Banner Description</label>
                  {/* <textarea className="form-control" name="bannerDescription"
                                        id="bannerDescription" onChange={this.handleChange}
                                        defaultValue={this.state.bannerDescription}
                                    ></textarea> */}
                  <ContentTextEditor
                    textEditorName={"banner"}
                    id="bannerDescription"
                    name="bannerDescription"
                    defaultValue={this.state.bannerDescription}
                    onChange={this.handleChange}
                  ></ContentTextEditor>
                </div>

                <div className="form-group mt-4" style={{ display: "none" }}>
                  <button type="button" className="btn btn-primary">
                    {" "}
                    What you'll do
                  </button>
                </div>
                <div id="whatyoudo">
                  <label for="bannerTitle">Course Details</label>
                  <div className="form-group" style={{ display: "none" }}>
                    <label for="whatyoudo_Description"> Description</label>
                    {/* <textarea className="form-control" name="whatyoudo_Description"
                                            id="whatyoudo_Description" onChange={this.handleChange}
                                            defaultValue={this.state.whatyoudo_Description}
                                        ></textarea> */}
                    <ContentTextEditor
                      textEditorName={"whatyoudo"}
                    ></ContentTextEditor>
                  </div>
                  <div className="">
                    <input
                      type="text"
                      className=""
                      name="rightModelTitle" style={{ display: "none" }}
                      id="rightModelTitle"
                      onChange={this.handleChange}
                      placeholder="Right Model Title"
                    />
                    <input
                      type="text"
                      className="form-control"
                      name="modelDate"
                      id="modelDate"
                      onChange={this.handleChange}
                      placeholder="Course Date"
                      style={{ width: "250px" }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      name="modelPrice"
                      id="modelPrice"
                      onChange={this.handleChange}
                      style={{ width: "250px", marginLeft: "270px", marginTop: "-34px" }}
                      placeholder="Course Price"
                    />
                    <input
                      type="text"
                      className="form-control"
                      name="modelDuration"
                      id="modelDuration"
                      onChange={this.handleChange}
                      style={{ width: "250px", marginLeft: "542px", marginTop: "-34px" }}
                      placeholder="Course Duration"
                    />
                    <input
                      type="button"
                      value="Add"
                      onClick={() => this.whatyoudoRight()}
                      style={{ marginTop: "10px" }}
                    />
                    {console.log("hhhh", this.state.modelRight)}
                    {this.state.modelRight.length > 0 && (
                      <table
                        className="table table-bordered"
                        style={{ marginTop: "10px" }}
                      >
                        <thead>
                          <tr>
                            <td>Date</td>
                            <td>Price</td>
                            <td>Duration</td>
                            <td>Action</td>
                          </tr>
                        </thead>{" "}
                        <tbody>
                          {this.state.modelRight.map((data, i) => {
                            return (
                              <tr>
                                <td>{data.date}</td>
                                <td>{data.price}</td>
                                <td>{data.duration}</td>
                                <td>
                                  <img
                                    src={closeImg}
                                    alt=""
                                    onClick={() =>
                                      this.modelRightRemove(
                                        data.date,
                                        data.price,
                                        data.duration
                                      )
                                    }
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>

                <div className="form-group mt-4" style={{ display: "none" }}>
                  <button type="button" className="btn btn-primary">
                    {" "}
                    What You Will Learn
                  </button>
                </div>
                <div id="WhatYouWillLearn" style={{ display: "none" }}>
                  <div className="form-group">
                    <label for="WhatYouWillLearnTitle">Title</label>
                    <input
                      type="text"
                      className="form-control"
                      name="WhatYouWillLearnTitle"
                      id="WhatYouWillLearnTitle"
                    />
                  </div>
                  <div className="form-group">
                    <label for="WhatYouWillLearnDescription">Description</label>
                    {/* <textarea className="form-control" name="WhatYouWillLearnDescription"
                                            id="WhatYouWillLearnDescription"
                                        ></textarea> */}
                    <ContentTextEditor
                      textEditorName={"WhatYouWillLearn"}
                    ></ContentTextEditor>
                    <input
                      type="button"
                      value="Add"
                      onClick={() => this.WhatYouWillLearnAdd()}
                      style={{ marginTop: "10px" }}
                    />
                  </div>
                  {this.state.WhatYouWillLearnArray.length > 0 && (
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <td>Title</td>
                          <td>Description</td>
                          <td>Delete</td>
                        </tr>
                      </thead>{" "}
                      <tbody>
                        {this.state.WhatYouWillLearnArray.map((data, i) => {
                          return (
                            <tr>
                              <td>{data.title}</td>
                              <td>{data.description}</td>
                              <td>
                                <img
                                  src={closeImg}
                                  alt=""
                                  onClick={() =>
                                    this.WhatYouWillLearnArrayRemove(
                                      data.title,
                                      data.description
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>

                <div className="form-group mt-4" style={{ display: "none" }}>
                  <button type="button" className="btn btn-primary">
                    What You Will Get
                  </button>
                </div>
                <div id="WhatYouWillGet" style={{ display: "none" }}>
                  <div className="form-group">
                    <label for="WhatYouWillGetTitle">Title</label>
                    <input
                      type="text"
                      className="form-control"
                      name="WhatYouWillGetTitle"
                      id="WhatYouWillGetTitle"
                    />

                    <input
                      type="button"
                      value="Add"
                      onClick={() => this.WhatYouWillGetAdd()}
                      style={{ marginTop: "10px" }}
                    />
                  </div>
                  {this.state.WhatYouWillGetArray.length > 0 && (
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <td>Title</td>
                          <td>Delete</td>
                        </tr>
                      </thead>{" "}
                      <tbody>
                        {this.state.WhatYouWillGetArray.map((data, i) => {
                          return (
                            <tr>
                              <td>{data.title}</td>
                              <td>
                                <img
                                  src={closeImg}
                                  alt=""
                                  onClick={() =>
                                    this.WhatYouWillGetRemove(data.title)
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>

                <div className="form-group mt-4" style={{ display: "none" }}>
                  <button type="button" className="btn btn-primary">
                    {" "}
                    How does it work
                  </button>
                </div>
                <div id="Howdoesitwork" style={{ display: "none" }}>
                  <div className="form-group">
                    <label for="HowdoesitworkTitle">Title</label>
                    <input
                      type="text"
                      className="form-control"
                      name="HowdoesitworkTitle"
                      id="HowdoesitworkTitle"
                    />
                  </div>
                  <div className="form-group">
                    <label for="HowdoesitworkDescription">Description</label>
                    {/* <textarea className="form-control" name="HowdoesitworkDescription"
                                            id="HowdoesitworkDescription"
                                        ></textarea> */}
                    <ContentTextEditor
                      textEditorName={"Howdoesitwork"}
                    ></ContentTextEditor>
                    <input
                      type="button"
                      value="Add"
                      onClick={() => this.HowdoesitworkAdd()}
                      style={{ marginTop: "10px" }}
                    />
                  </div>
                  {this.state.HowdoesitworkArray.length > 0 && (
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <td>Title</td>
                          <td>Description</td>
                          <td>Delete</td>
                        </tr>
                      </thead>{" "}
                      <tbody>
                        {this.state.HowdoesitworkArray.map((data, i) => {
                          return (
                            <tr>
                              <td>{data.title}</td>
                              <td>{data.description}</td>
                              <td>
                                <img
                                  src={closeImg}
                                  alt=""
                                  onClick={() =>
                                    this.HowdoesitworkArrayRemove(
                                      data.title,
                                      data.description
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>

                <div className="form-group mt-4" style={{ display: "none" }}>
                  <button type="button" className="btn btn-primary">
                    Platforms & Tools
                  </button>
                </div>
                <div id="PlatformsTools" style={{ display: "none" }}>
                  <div className="form-group">
                    <input
                      type="file"
                      className="form-control"
                      name="PlatformsToolsFile"
                      id="PlatformsToolsFile"
                      onChange={this.handleChangePlatformsToolsFile}
                    />

                    <input
                      type="button"
                      value="Add"
                      onClick={() => this.PlatformsToolsAdd()}
                      style={{ marginTop: "10px" }}
                    />
                  </div>
                  {this.state.PlatformsToolsFiles.length > 0 && (
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <td>Url</td>
                          <td>Delete</td>
                        </tr>
                      </thead>{" "}
                      <tbody>
                        {this.state.PlatformsToolsFiles.map((data, i) => {
                          return (
                            <tr>
                              <td>
                                <img src={data.url} width="20%" />
                              </td>
                              <td>
                                <img
                                  src={closeImg}
                                  alt=""
                                  onClick={() =>
                                    this.PlatformsToolsRemove(data.url)
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>

                <div className="form-group mt-4" style={{ display: "none" }}>
                  <button type="button" className="btn btn-primary">
                    Certifications
                  </button>
                </div>
                <div id="Certifications" style={{ display: "none" }}>
                  <div className="form-group">
                    <input
                      type="file"
                      className="form-control"
                      name="CertificationsFile"
                      id="CertificationsFile"
                      onChange={this.handleChangeCertifications}
                    />
                    <input
                      type="button"
                      value="Add"
                      onClick={() => this.CertificationsAdd()}
                      style={{ marginTop: "10px" }}
                    />
                  </div>
                  {this.state.CertificationsFiles.length > 0 && (
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <td>Url</td>
                          <td>Delete</td>
                        </tr>
                      </thead>{" "}
                      <tbody>
                        {this.state.CertificationsFiles.map((data, i) => {
                          return (
                            <tr>
                              <td>
                                <img src={data.url} width="20%" />
                              </td>
                              <td>
                                <img
                                  src={closeImg}
                                  alt=""
                                  onClick={() =>
                                    this.CertificationsRemove(data.url)
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>

                <div className="form-group mt-4" style={{display:"none"}}>
                  <button type="button" className="btn btn-primary">
                    Course Details
                  </button>
                </div>
                <div id="Certifications">
                  <div className="form-group">
                    <label for="WhatYouWillLearnTitle">University Name</label>
                    <select
                        id="universityName"
                        name="universityName"
                        className="form-control"
                      >
                        {this.state.institution.map((data, i) => {
                          return (
                            <option value={data.internalId}>{data.institution}</option>
                          );
                        })}
                      </select>
                    {/* <input
                      type="text"
                      className="form-control"
                      name="universityName"
                      onChange={this.handleChange}
                      id="universityName"
                      placeholder="University Name"
                    /> */}
                  </div>
                  <div className="form-group">
                    <label for="WhatYouWillLearnTitle">
                      Course Description
                    </label>
                    <textarea
                      className="form-control"
                      name="courseDescription"
                      placeholder="Course Description"
                      onChange={this.handleChange}
                      id="courseDescription"
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <label for="WhatYouWillLearnTitle">Language</label>
                    <textarea
                      className="form-control"
                      name="Language"
                      placeholder="Language"
                      onChange={this.handleChange}
                      id="Language"
                    ></textarea>
                  </div>
                  <div className="form-group" style={{ display: "none" }}>
                    <label for="WhatYouWillLearnTitle">Course rating</label>
                    <textarea
                      className="form-control"
                      name="Courserating"
                      placeholder="Course rating"
                      onChange={this.handleChange}
                      id="Courserating"
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <label for="WhatYouWillLearnTitle">Level</label>
                    <textarea
                      className="form-control"
                      name="Level"
                      placeholder="Level"
                      onChange={this.handleChange}
                      id="Level"
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <label for="WhatYouWillLearnTitle">Mode of learning</label>
                    <div className="form-group">
                      <select
                        id="Modeoflearning"
                        name="Modeoflearning"
                        className="form-control"
                      >
                        {this.state.modeoflearning.map((data, i) => {
                          return (
                            <option value={data.internalId}>{data.modeOfLearning}</option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="form-group">
                    <label for="WhatYouWillLearnTitle">Country</label>
                    <div className="form-group">
                      <select
                        id="Country"
                        name="Country"
                        className="form-control"
                      >
                        {this.state.country.map((data, i) => {
                          return (
                            <option value={data.key}>{data.country}</option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="form-group">
                    <label for="WhatYouWillLearnTitle">Accrediation</label>
                    <textarea
                      className="form-control"
                      name="Accrediation"
                      placeholder="Accrediation"
                      onChange={this.handleChange}
                      id="Accrediation"
                    ></textarea>
                  </div>
                  <div className="form-group" style={{ display: "none" }}>
                    <label for="WhatYouWillLearnTitle">Accredtion score</label>
                    <textarea
                      className="form-control"
                      name="Accredtionscore"
                      placeholder="Accredtion score"
                      onChange={this.handleChange}
                      id="Accredtionscore"
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <label for="WhatYouWillLearnTitle">Website link</label>
                    <textarea
                      className="form-control"
                      name="Websitelink"
                      placeholder="Website link"
                      onChange={this.handleChange}
                      id="Websitelink"
                    ></textarea>
                  </div>
                </div>

                <div className="form-group mt-4">
                  <button type="button" className="btn btn-primary">
                    Skills
                  </button>
                </div>
                <div id="WhatYouWillGet">
                  <div className="form-group">
                    <label for="WhatYouWillGetTitle">Skills</label>
                    <select
                      className="form-control"
                      name="skilsName"
                      id="skilsName"
                      style={{ width: "500px" }}
                    >
                      <option value="">Please select....</option>
                      {this.state.skillsObj.map((data, i) => {
                        return (
                          <option value={data.skills}>{data.skills}</option>
                        );
                      })}
                    </select>
                    <input
                      type="text"
                      className="form-control" style={{ marginLeft: "524px", marginTop: "-34px", width: "255px", display: "none" }}
                      name="skillRating"
                      id="skillRating"
                      onChange={this.handleChange}
                      placeholder="Skill Rating"
                      onKeyUp={this.handleNumberChange}
                    />

                    <input
                      type="button"
                      value="Add"
                      onClick={() => this.skillAdd()}
                      style={{ marginTop: "10px" }}
                    />
                  </div>
                  {this.state.skillArray.length > 0 && (
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <td>Skill</td>
                          <td style={{ display: "none" }}>Rating</td>
                          <td>Delete</td>
                        </tr>
                      </thead>{" "}
                      <tbody>
                        {this.state.skillArray.map((data, i) => {
                          return (
                            <tr>
                              <td>{data.skill}</td>
                              <td style={{ display: "none" }}>{data.skillRating}</td>
                              <td>
                                <img
                                  src={closeImg}
                                  alt=""
                                  onClick={() => this.skillRemove(data.skill)}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>

                <div id="Certifications">
                  <div className="form-group">
                    <label for="WhatYouWillLearnTitle">Course Fields</label>
                  </div>
                  <div className="form-group">
                    <label for="WhatYouWillLearnTitle">
                      What Does the Course Cover?
                    </label>
                    <br></br>
                    Length and Breadth of the Skills Being Covered - out of 10
                    <input
                      type="text"
                      className="form-control"
                      name="LengthandBreadth"
                      onChange={this.handleChange}
                      id="LengthandBreadth"
                      style={{ width: "100px" }}
                      placeholder="out of 10"
                      title="Length and Breadth of the Skills Being Covered - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    <br></br>
                    Relevant Case Studies Covered by the Course - out of 10
                    <input
                      type="text"
                      className="form-control"
                      name="RelevantCaseStudies"
                      onChange={this.handleChange}
                      id="RelevantCaseStudies"
                      style={{ width: "100px" }}
                      placeholder="out of 10"
                      title="Relevant Case Studies Covered by the Course - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    <br></br>
                    Tools Covered by the Course - out of 10
                    <input
                      type="text"
                      className="form-control"
                      name="ToolsCovered"
                      onChange={this.handleChange}
                      id="ToolsCovered"
                      style={{ width: "100px" }}
                      placeholder="out of 10"
                      title="Tools Covered by the Course - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    <br></br>
                    Capstone Project Covered by the Course - out of 10
                    <input
                      type="text"
                      className="form-control"
                      name="CapstoneProjectCovered"
                      onChange={this.handleChange}
                      id="CapstoneProjectCovered"
                      style={{ width: "100px" }}
                      placeholder="out of 10"
                      title="Capstone Project Covered by the Course- out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    <br></br>
                    <label for="WhatYouWillLearnTitle">
                      Trainers - Who are the Trainers Behind the Course?
                    </label>
                    <br></br>
                    Trainer's Experience - out of 10
                    <input
                      type="text"
                      className="form-control"
                      name=" TrainerExperience"
                      onChange={this.handleChange}
                      id="TrainerExperience"
                      style={{ width: "100px" }}
                      placeholder="out of 10"
                      title="Trainer's Experience - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    <br></br>
                    Trainer's Education - out of 10
                    <input
                      type="text"
                      className="form-control"
                      name="TrainerEducation"
                      onChange={this.handleChange}
                      id="TrainerEducation"
                      style={{ width: "100px" }}
                      placeholder="out of 10"
                      title="Trainer's Education - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    <br></br>
                    Teaching Style of the Trainers - out of 10
                    <input
                      type="text"
                      className="form-control"
                      name="TeachingStyle"
                      onChange={this.handleChange}
                      id="TeachingStyle"
                      style={{ width: "100px" }}
                      placeholder="out of 10"
                      title="Teaching Style of the Trainers - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    <br></br>
                    <label for="WhatYouWillLearnTitle">
                      Accreditations - What are the Certificates and
                      Accreditations of this Course?
                    </label>
                    <br></br>
                    Ranking/Govt. Bodies/Professional Bodies - out of 10
                    <input
                      type="text"
                      className="form-control"
                      name="Ranking"
                      onChange={this.handleChange}
                      id="Ranking"
                      style={{ width: "100px" }}
                      placeholder="out of 10"
                      title="Ranking - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    {/* <br></br>
                    Govt. Bodies - out of 10 */}
                    <input
                      type="text"
                      className="form-control"
                      name="GovtBodies"
                      onChange={this.handleChange}
                      id="GovtBodies"
                      style={{ width: "100px", display: "none" }}
                      placeholder="out of 10"
                      title="Govt. Bodies - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    {/* <br></br>
                    Professional Bodies - out of 10 */}
                    <input
                      type="text"
                      className="form-control"
                      name="ProfessionalBodies"
                      onChange={this.handleChange}
                      id="ProfessionalBodies"
                      style={{ width: "100px", display: "none" }}
                      placeholder="out of 10"
                      title="Professional Bodies - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    <br></br>
                    <label for="WhatYouWillLearnTitle">
                      Delivery Methods Grading - What are the Delivery Methods
                      of the course?
                    </label>
                    <br></br>
                    {/* Mentorship - out of 10 */}
                    <input
                      type="text"
                      className="form-control"
                      name="Mentorship"
                      onChange={this.handleChange}
                      id="Mentorship"
                      style={{ width: "100px", display: "none" }}
                      placeholder="out of 10"
                      title="Mentorship - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    {/* <br></br> */}
                    {/* Career Coach - out of 10 */}
                    <input
                      type="text"
                      className="form-control"
                      name="CareerCoach"
                      onChange={this.handleChange}
                      id="CareerCoach"
                      style={{ width: "100px", display: "none" }}
                      placeholder="out of 10"
                      title="Career Coach - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    {/* <br></br> */}
                    {/* Live classes - out of 10 */}
                    <input
                      type="text"
                      className="form-control"
                      name="Liveclasses"
                      onChange={this.handleChange}
                      id="Liveclasses"
                      style={{ width: "100px", display: "none" }}
                      placeholder="out of 10"
                      title="Live classes - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    {/* <br></br> */}
                    Quick Upskilling - out of 10
                    <input
                      type="text"
                      className="form-control"
                      name="QuickUpskilling"
                      onChange={this.handleChange}
                      id="QuickUpskilling"
                      style={{ width: "100px" }}
                      placeholder="out of 10"
                      title="Quick Upskilling - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    <br></br>
                    Active Learning - out of 10
                    <input
                      type="text"
                      className="form-control"
                      name="ActiveLearning"
                      onChange={this.handleChange}
                      id="ActiveLearning"
                      style={{ width: "100px" }}
                      placeholder="out of 10"
                      title="Active Learning  - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    <br></br>
                    Job Assistance - out of 10
                    <input
                      type="text"
                      className="form-control"
                      name="JobAssistance"
                      onChange={this.handleChange}
                      id="JobAssistance"
                      style={{ width: "100px" }}
                      placeholder="out of 10"
                      title="Job Assistance - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    <br></br>
                    Study Materials Provided by the Course - out of 10
                    <input
                      type="text"
                      className="form-control"
                      name="StudyMaterials"
                      onChange={this.handleChange}
                      id="StudyMaterials"
                      style={{ width: "100px" }}
                      placeholder="out of 10"
                      title="Study Materials Provided by the Course - out of 10"
                      onKeyUp={this.handleNumberChange}
                    />
                    <br></br>
                    <label for="WhatYouWillLearnTitle" style={{ display: "none" }}>
                      Overall Outcome- What are the final outcomes of this
                      course?
                    </label>
                    {/* <br></br> */}
                    <div style={{ display: "none" }}>
                      Career Transition
                      <input
                        type="checkbox"
                        className="form-control"
                        name="CareerTransition"
                        onChange={this.handleChange}
                        id="CareerTransition"
                        style={{ width: "20px", height: "20px" }}
                        placeholder=""
                        value="Career Transition"
                        title=" Career Transition"
                      />
                      <input
                        type="text"
                        className="form-control"
                        name="careerTransitionScore"
                        onChange={this.handleChange}
                        id="careerTransitionScore"
                        style={{ width: "100px", marginLeft: "50px", marginTop: "-25px" }}
                        placeholder="out of 10"
                        title="Mentorship - out of 10"
                        onKeyUp={this.handleNumberChange}
                      />
                      Quick Upskills
                      <input
                        type="checkbox"
                        className="form-control"
                        name="QuickUpskills"
                        onChange={this.handleChange}
                        id="QuickUpskills"
                        style={{ width: "20px", height: "20px" }}
                        placeholder=""
                        value=" Quick Upskills"
                        title=" Quick Upskills"
                      />
                      <input
                        type="text"
                        className="form-control"
                        name="quickUpskillsScore"
                        onChange={this.handleChange}
                        id="quickUpskillsScore"
                        style={{ width: "100px", marginLeft: "50px", marginTop: "-25px" }}
                        placeholder="out of 10"
                        title="Mentorship - out of 10"
                        onKeyUp={this.handleNumberChange}
                      />
                      Jobs
                      <input
                        type="checkbox"
                        className="form-control"
                        name="Jobs"
                        onChange={this.handleChange}
                        id="Jobs"
                        style={{ width: "20px", height: "20px" }}
                        placeholder=""
                        value="Jobs"
                        title="Jobs"
                      />
                      <input
                        type="text"
                        className="form-control"
                        name="jobsScore"
                        onChange={this.handleChange}
                        id="jobsScore"
                        style={{ width: "100px", marginLeft: "50px", marginTop: "-25px" }}
                        placeholder="out of 10"
                        title="Mentorship - out of 10"
                        onKeyUp={this.handleNumberChange}
                      />
                      Certificates
                      <input
                        type="checkbox"
                        className="form-control"
                        name="CertificatesCheck"
                        onChange={this.handleChange}
                        id="CertificatesCheck"
                        style={{ width: "20px", height: "20px" }}
                        placeholder=""
                        value="Certificates"
                        title="Certificates"
                      />
                      <input
                        type="text"
                        className="form-control"
                        name="certificatesScore"
                        onChange={this.handleChange}
                        id="certificatesScore"
                        style={{ width: "100px", marginLeft: "50px", marginTop: "-25px" }}
                        placeholder="out of 10"
                        title="Mentorship - out of 10"
                        onKeyUp={this.handleNumberChange}
                      />
                    </div>
                    <br></br>
                    <input
                      type="button"
                      id=""
                      value="Calculate Score"
                      onClick={() => this.scoreCalculate()}
                    />
                    <span id="scoreValue" style={{ marginLeft: "10px" }}><b>{this.state.CourseScore} %</b></span>
                  </div>
                </div>

                <div className="form-group mt-4">
                  <Link to="/career-tracks">
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ float: "right", marginLeft: "10px" }}
                    >
                      Cancel
                    </button>
                  </Link>
                  {this.state.id == null ? (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={this.validateSubmission}
                      style={{ float: "right" }}
                    >
                      Submit
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={this.validateSubmission}
                      style={{ float: "right" }}
                    >
                      Update
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>

        <Footer></Footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/CareerTracks/newCourse.jsx